import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-profile-contact',
  templateUrl: './profile-contact.component.html',
  styleUrls: ['./profile-contact.component.css'],
})
export class ProfileContactComponent {
  @Input() email!: any;
  @Input() phoneNumber!: any;
  @Input() linkedInLink!: any;
  @Input() cvUrl!: any;
  @Input() name!: any;
  // @Input() mode: 'view' | 'edit' = 'view';
  constructor(private sanitizer: DomSanitizer) {}

  // Safe CV URL
  getCvUrl(): SafeResourceUrl {
    const cleanUrl = this.buildCvPath(this.cvUrl);
    return this.sanitizer.bypassSecurityTrustUrl(cleanUrl);
  }

  // Safe LinkedIn URL
  get linkedInUrl(): SafeResourceUrl {
    const cleanUrl = this.extractLinkedInUrl(this.linkedInLink);
    return this.sanitizer.bypassSecurityTrustUrl(cleanUrl);
  }

  private buildCvPath(cvUrl: string): string {
    if (!cvUrl) return '';

    // Fix 1: Replace backslashes with forward slashes
    let cleanPath = cvUrl.replace(/\\/g, '/');

    // Fix 2: Remove "pdf" suffix without a dot (like "...pdf" → "...")
    if (cleanPath.endsWith('pdf') && !cleanPath.endsWith('.pdf')) {
      cleanPath = cleanPath.slice(0, -3); // Remove last 3 chars "pdf"
    }

    // Fix 3: Ensure .pdf extension exists
    if (!cleanPath.endsWith('.pdf')) {
      cleanPath += '.pdf';
    }

    // Build full URL - don't add extra slash if apiCvPath already has it
    const fullPath = environment.apiCvPath.endsWith('/')
      ? environment.apiCvPath + cleanPath
      : environment.apiCvPath + '/' + cleanPath;

    return fullPath;
  }

  private extractLinkedInUrl(linkedInLink: string): string {
    if (!linkedInLink) return '';

    // Extract URL from markdown syntax: [text](url)
    const urlMatch = linkedInLink.match(/\[(.*?)\]\((.*?)\)/);
    if (urlMatch && urlMatch[2]) {
      return urlMatch[2]; // Return the URL part
    }

    // If it's just text like "www.linkedin.com/..."
    if (linkedInLink.startsWith('www.')) {
      return 'https://' + linkedInLink;
    }

    // Already a full URL
    return linkedInLink;
  }
}
